import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createPricePlanCalculator(
  parentId: string,
  masterBlockId?: MasterBlockId,
): PricePlanCalculatorInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.PricePlanCalculator,
      parentId,
      masterBlockId,
    ),
    popupId: null,
  }
}
